import { gql } from '@apollo/client';
import { CAR_DETAIL_FRAGMENT } from '../../../common/graphqlQueries/fragments';

export const GET_UPCOMING_INVENTORY = gql`
  query getUpcomingInventory(
    $page: Int
    $search: String
    $orderBy: String
    $filters: [FilterInputType!]
    $workshopId: String!
    $extraData: [String!]
  ) {
    getUpcomingInventory(
      page: $page
      search: $search
      orderBy: $orderBy
      filters: $filters
      workshopId: $workshopId
      extraData: $extraData
    ) {
      data {
        id
        source
        sourceId
        clientData
        car {
          ...CarDetail
        }
        expectedWorkshop {
          id
        }
        refurbCategory
        status
        reportId
        workshop {
          id
          name
          displayName
        }
        customer {
          id
          name
          displayName
        }
        createdAt
        metaData
      }
      hubLocations
      extraData {
        key
        value
      }
      orderBy
      filters {
        key
      }
      paginator {
        totalItems
        perPage
        numPages
        currentPage
      }
    }
  }
  ${CAR_DETAIL_FRAGMENT}
`;

export const GET_CHILD_WORKSHOPS = gql`
  query getChildWorkshops($workshopId: String!) {
    getChildWorkshops(parentWorkshopId: $workshopId) {
      id
      name
      displayName
      state
    }
  }
`;

export const GET_ADVISORS_FOR_UPCOMING_V3 = gql`
  query getAvailableWorkshopCgtForMake($assignedWorkshopId: String!, $make: String!) {
    getAvailableWorkshopCgtForMake(workshopId: $assignedWorkshopId, make: $make) {
      id
      user {
        id
        fullName
      }
      score
      userCapacity {
        availableCapacity
        maxCapacity
      }
    }
  }
`;
// totalCurrentJoblistsAssignedToTechnician
// usermakemetricUser {
//   score
//   userCapacity {
//     availableCapacity
//     maxCapacity
//   }
// }
